import { DisclosureSection } from '@components/core-ui/DisclosureSection';
import { showcasePagePanelClassName } from '@pages/Admin/ComponentShowcasePage/helpers/showcasePagePanelClassName';
import { showcaseSurfacePanelClassName } from '@pages/Admin/ComponentShowcasePage/helpers/showcaseSurfacePanelClassName';
import { useState } from 'react';

const sectionBody = <p className="text-sm text-[var(--color-text)]">Collapsible content for theme verification.</p>;

const variantLabelClassName = 'mb-2 text-xs font-medium text-foreground-muted';

export const DisclosureSectionDemo = () => {
  const [openOnSurface, setOpenOnSurface] = useState(true);
  const [openOnPage, setOpenOnPage] = useState(true);

  return (
    <div className="flex flex-col gap-8">
      <div>
        <p className={variantLabelClassName}>On surface (modal)</p>
        <div className={showcaseSurfacePanelClassName}>
          <DisclosureSection
            title="Section title"
            open={openOnSurface}
            setOpenState={setOpenOnSurface}
            loading={false}
            titleClassName="!bg-[var(--color-surface)]"
          >
            {sectionBody}
          </DisclosureSection>
        </div>
      </div>
      <div className={showcasePagePanelClassName}>
        <p className={variantLabelClassName}>On page background</p>
        <DisclosureSection title="Section title" open={openOnPage} setOpenState={setOpenOnPage} loading={false}>
          {sectionBody}
        </DisclosureSection>
      </div>
    </div>
  );
};
